<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="packerContainerFileForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                packerContainerFileForm: () => import('../forms/PackerContainerFileForm'),
                headers: [
                    { text: 'Packer Container', value: 'packerContainerId', table: 'packerContainers', form: () => import('../forms/PackerContainerForm') },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: 'File Type', value: 'fileType', format: this.formatEnum },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    files: [],
                    packerContainers: [],
                    items: []
                },
                sorting: [
                    { column: "packerContainerId", direction: "ascending" },
                    { column: "fileId", direction: "ascending" },
                ],
                itemsField: 'packerContainerFiles',
                editPageName: 'packerContainerFile',
                apiMethod: 'PackerContainerFiles',
                claimName: 'PackerContainerFiles',
                formTitle: 'Packer Container File',
                excelTitle: 'Packer Container Files',
                hasEditPage: false,
            }
        },
    };
</script>
